import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  totalCount: {
    color: theme.palette.text.disabled,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    paddingBottom: '10px',
  },
}));
